export default {
  startsOnNewPage: 'Start on new page',
};
